import { AfterViewInit, Component } from '@angular/core';

declare global {
  interface Window {
    attachEvent: any;
    callParentFunction: any;
    receiveMessage: any;
  }
}

@Component({
    selector: 'app-iframe',
    template: '',
    standalone: false
})
export class IframeComponent implements AfterViewInit {
  ngAfterViewInit(): void {
    window.callParentFunction = (str) => {
      if (
        str &&
        str.length > 0 &&
        window.parent &&
        window.parent.parent &&
        window.parent.parent.CommunicationHandler &&
        window.parent.parent.CommunicationHandler.onReceiveCommunication
      ) {
        let referrer = document.referrer;
        window.parent.parent.CommunicationHandler.onReceiveCommunication({
          qstr: str,
          parent: referrer,
        });
      }
    };

    window.receiveMessage = (event) => {
      if (event && event.data) {
        window.callParentFunction(event.data);
      }
    };
    if (window.location.hash && window.location.hash.length > 1) {
      window.callParentFunction(window.location.hash.substring(1));
    }
    if (window.addEventListener) {
      window.addEventListener('message', window.receiveMessage, false);
    } else if (window.attachEvent) {
      window.attachEvent('onmessage', window.receiveMessage);
    }
  }
}
